import Axios from 'axios';
import { Config } from '../apiRoutes';

import {
  INCOMPLETE_ORDERS_REQUESTED,
  INCOMPLETE_ORDERS_SUCCESS,
  INCOMPLETE_ORDERS_FAILURE
} from '../types';

export const incompleteOrdersRequested = () => {
  return {
    type: INCOMPLETE_ORDERS_REQUESTED
  }
};

export const incompleteOrdersSuccess = (orders) => {
  return {
    type: INCOMPLETE_ORDERS_SUCCESS,
    payload: orders
  }
};

export const incompleteOrdersFailure = () => {
  return {
    type: INCOMPLETE_ORDERS_FAILURE
  }
};

export const getIncompleteOrders = (ecwidPayload, orderPage, selectedSearchStatus) => {
  return (dispatch) => {
    dispatch(incompleteOrdersRequested());

    let endPoint = Config.baseUrl + Config.orders + Config.incomplete + `?page=${orderPage}&status=${selectedSearchStatus}`;
    let headers = Object.assign(Config.headers);
    headers.payload = ecwidPayload;

    return Axios.get(endPoint, { headers: headers })
      .then((response) => {
        dispatch(incompleteOrdersSuccess(response.data));
      })
  }
}

